<template>
    <div class="preview-report mb-4">
        <h6 class="preview-report__title">
            {{ title }}
        </h6>
        <div
            :class="['preview-report__verdict', verdictSafe ? 'preview-report__verdict--safe' : 'preview-report__verdict--unsafe']"
        >
            {{ verdictText }}
        </div>
        <DAlert
            v-if="warning"
            color="warning"
            class="preview-report__warning"
        >
            ⚠ {{ warning }}
        </DAlert>
        <table class="preview-report__table">
            <tbody>
                <tr
                    v-for="(row, index) in rows"
                    :key="index"
                >
                    <td class="preview-report__label">
                        {{ row.label }}
                    </td>
                    <td class="preview-report__count">
                        {{ row.count }}
                    </td>
                    <td class="preview-report__hint">
                        {{ row.hint }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div
            v-if="conflictingRecords && Object.keys(conflictingRecords).length > 0"
            class="preview-report__conflicts mt-2"
        >
            <span class="preview-report__label">
                {{ conflictingRecordsLabel }}:
            </span>
            <div
                v-for="(pks, className) in conflictingRecords"
                :key="className"
                class="preview-report__conflict-row"
            >
                <span class="preview-report__conflict-class">{{ className }}:</span>
                <span class="preview-report__conflict-pks">{{ pks.join(', ') }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>

defineProps({
    title: {
        type: String,
        default: ''
    },
    verdictText: {
        type: String,
        default: ''
    },
    verdictSafe: {
        type: Boolean,
        default: true
    },
    rows: {
        type: Array,
        default: () => { return [] }
    },
    conflictingRecords: {
        type: Object,
        default: null
    },
    conflictingRecordsLabel: {
        type: String,
        default: ''
    },
    warning: {
        type: String,
        default: null
    }
})
</script>

<style lang="scss" scoped>
.preview-report {
    border: 1px solid var(--colorAppBorder);
    border-radius: 4px;
    padding: 0.75rem 1rem;
    background: var(--cui-body-bg);
}

.preview-report__title {
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: var(--cui-body-color);
    opacity: 0.75;
}

.preview-report__verdict {
    font-weight: 600;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
}

.preview-report__verdict--safe {
    color: #2eb85c;
}

.preview-report__verdict--unsafe {
    color: #e55353;
}

.preview-report__warning {
    font-size: 0.875rem;
    font-weight: 600;
}

.preview-report__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.875rem;

    td {
        padding: 0.125rem 0;
    }
}

.preview-report__label {
    color: var(--cui-body-color);
    opacity: 0.75;
    width: 100px;
}

.preview-report__count {
    font-weight: 600;
    width: 50px;
}

.preview-report__hint {
    color: var(--cui-body-color);
    opacity: 0.5;
    font-style: italic;
}

.preview-report__conflicts {
    font-size: 0.875rem;
}

.preview-report__conflict-row {
    padding-left: 0.5rem;
}

.preview-report__conflict-class {
    font-weight: 600;
    margin-right: 0.25rem;
    color: var(--cui-body-color);
    opacity: 0.75;
}

.preview-report__conflict-pks {
    color: var(--cui-body-color);
    opacity: 0.6;
}
</style>
